import { NavigationStore } from './mobx/navigation-store';
import { createContext } from 'react';

export const NavigationContext = createContext<NavigationStore>(
  new NavigationStore()
);
